import React from "react";

import { Text, useTheme } from "@bps/fluent-ui";

interface DeploymentDetailTimelineBoxProps {
  props: React.HTMLAttributes<HTMLDivElement>;
  id: string;
  isSmallBar: boolean;
  text: string;
  ratio: number;
}

export const DeploymentDetailTimelineBox: React.FC<DeploymentDetailTimelineBoxProps> = ({
  props,
  id,
  isSmallBar,
  text,
  ratio
}) => {
  const theme = useTheme();

  return (
    <div
      {...props}
      id={id}
      key={id}
      style={{
        ...props.style,
        height: isSmallBar ? 18 : 36,
        marginTop: isSmallBar ? 0 : 20,
        borderRadius: 4,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        userSelect: "none",
        boxShadow: "0 0 4px rgba(0,0,0,0.15)",
        zIndex: 100,
        minWidth: "15px"
      }}
    >
      {!isSmallBar && (
        <div
          style={{
            position: "absolute",
            left: `${ratio * 100}%`,
            height: "100%",
            zIndex: -10,
            borderLeft: "2px dotted orange"
          }}
        />
      )}
      <Text
        styles={{
          root: {
            pointerEvents: "none",
            color: theme.palette.white,
            fontWeight: "bold",
            fontSize: 12,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "clip"
          }
        }}
      >
        {text}
      </Text>
    </div>
  );
};
